// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"ea4e24ec","32":"658270b7","57":"cb1a85e3","327":"85698876","453":"c287c6e1","480":"1d5073ec","568":"452b0034","601":"2661f968","668":"1de29cbc","669":"73580852","679":"210e6a4c","717":"2fd3dc1f","753":"215e81d3","762":"474b1ed9","826":"0e49567c"}[chunkId] + ".chunk.js";
};